import React, {FC} from "react"
import {Col, Row} from "@irati/ui/src/Layout"
import {Checkbox} from "@irati/ui/src/FormItem"
import {FormattedMessage, useIntl} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {OverlayPlacement, Tooltip} from "@irati/ui/src/Tooltip"
import {ButtonLink} from "@irati/ui/src/Link"
import tracking from "@irati-tracking/homepage/cultureHub"
import {useCultureHubStore} from "@irati-web/cultureHub/src/stores/hooks"

interface Props {}

const NotificationCheckbox: FC<Props> = () => {
  const {formatMessage} = useIntl()
  const {state, dispatch} = useCultureHubStore()

  return (
    <Row>
      <Col xs={12}>
        <Flex alignItems="center" justifyContent="space-between" marginTop={2} marginBottom={2}>
          <Checkbox
            flush
            name="notificationCheckbox"
            checked={state.isNotificationChecked}
            onChange={() => dispatch({type: "SET_NOTIFICATION", payload: {isNotificationChecked: !state.isNotificationChecked}})}>
            <Flex inline alignItems="center" gap={0.5}>
              <FormattedMessage id="culturehub.createTile.modal.notify" />
              <Tooltip
                placement={OverlayPlacement.Top}
                tooltipChildren={<FormattedMessage id="culturehub.companyNews.edit.notification.tooltip.text" />}>
                <Icon icon={IconTypes.information} />
              </Tooltip>
            </Flex>
          </Checkbox>
          <ButtonLink
            cta
            tertiary
            href={formatMessage({id: "culturehub.companyNews.edit.notification.FAQ.href"})}
            onClick={() => tracking.clickCultureHubCta("culturehub", "NotificationsFAQ")}
            target="_blank">
            <FormattedMessage id="culturehub.companyNews.edit.notification.FAQ.linkTitle" />
          </ButtonLink>
        </Flex>
      </Col>
    </Row>
  )
}

export default NotificationCheckbox
